import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ErrorState {
  errorMessage: string | null;
  errorContent: string | null;
  handleErrorMessageMount: (() => void | Promise<void>) | null;
  messageDuration: number | null;
}

const initialState: ErrorState = {
  errorMessage: null,
  errorContent: null,
  handleErrorMessageMount: null,
  messageDuration: 3,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setErrorMessage: (
      state,
      action: PayloadAction<{
        errorMessage: string;
        errorContent?: string;
        handleErrorMessageMount?: () => void | Promise<void>;
        messageDuration?: number | null;
      }>
    ) => {
      state.errorMessage = action.payload.errorMessage;
      state.errorContent = action.payload.errorContent ?? null;
      state.handleErrorMessageMount = action.payload.handleErrorMessageMount ?? null;
      state.messageDuration =
        action.payload.messageDuration === undefined ? 3 : action.payload.messageDuration;
    },
    clearErrorMessage: (state) => {
      state.errorMessage = null;
      state.errorContent = null;
      state.handleErrorMessageMount = null;
      state.messageDuration = 3;
    },
  },
});

export const { setErrorMessage, clearErrorMessage } = errorSlice.actions;
export default errorSlice.reducer;
